import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import './collaborativeIndexations.css'
import Summary from './Summary.jsx'
import Header from '../Aside/Header'
import { ReportingContainer } from './Reporting.js'

class CollaborativeIndexations extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
        fields: PropTypes.object,
    }

    render()
    {
        const { t, close, fields } = this.props

        let body = null
        if(fields !== null)
        {
            body = <div className="collaborative-indexations-body">
                    <Summary fields={fields} />
                    <ReportingContainer />
                </div>
        }

        return (
            <div className="collaborative-indexations">
                <Header
                    className='collaborative-indexations-header'
                    close={close}
                    title={t('visualizer:toolbar.left.collaborativeIndexations.title')}
                />
                {body}
            </div>
        )
    }
}

export default withTranslation()(CollaborativeIndexations)
